import { Row } from 'app/design/primitives/box';
import { Text } from 'app/design/primitives/text';

import { useScopedTranslation } from 'app/hooks/i18n';
import { useUISize } from 'app/utils/web-helpers';
import { useTranslation } from 'react-i18next';
import { Pressable } from 'react-native';
import { createTheme as createDSTheme } from 'app/shopify';
import { IconX } from '@tabler/icons-react-native';
import { ICON_STROKE_WIDTH } from 'app/utils/constants';
const theme = createDSTheme();

export const ModalTitle = ({ close, title }: { close: () => void; title?: string }) => {
  const { t } = useScopedTranslation();
  const { t: tA11y } = useTranslation();
  const foreground = theme.colors['text.primary'];
  const { isSmallUI } = useUISize();
  const displayTitle = title ?? t('headerTitle');

  if (isSmallUI) {
    return (
      <Row alignItems="center" flex={1} width="100%">
        <Pressable
          accessibilityLabel={tA11y('accessibility.close')}
          accessibilityRole="button"
          hitSlop={12}
          onPress={close}
        >
          <IconX strokeWidth={ICON_STROKE_WIDTH} size={28} color={foreground} />
        </Pressable>
        <Row flex={1} />
        <Text fontSize={16} fontWeight="700" style={{ color: foreground }}>
          {displayTitle}
        </Text>
        <Row flex={1} marginRight="spacing.general.x8" />
      </Row>
    );
  }

  return (
    <>
      <Row alignItems="center" justifyContent="space-between" flex={1} width="100%" marginTop="spacing.general.x4">
        <Row flex={1} />
        <Pressable
          accessibilityLabel={tA11y('accessibility.close')}
          accessibilityRole="button"
          hitSlop={12}
          onPress={close}
        >
          <IconX strokeWidth={ICON_STROKE_WIDTH} size={28} color={foreground} />
        </Pressable>
      </Row>
      <Row>
        <Text fontSize={20} fontWeight="700" style={{ color: foreground }}>
          {displayTitle}
        </Text>
      </Row>
    </>
  );
};
